import { defineComponent, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
// defineComponent 可以有智能提示
export default defineComponent({
  setup() {
    let store = useStore();
    const $router = useRouter();
    const agreementItem = localStorage.getItem('agreementItem') ? localStorage.getItem('agreementItem') : 'item1';
    // const agreementItem = store.state.agreementItem;
    const itemvalue = ref(agreementItem);
    // const goHomepage = () => {  $router.push({ path: '/softwarelibrary' }); };
    const goHomepage = () => {
      $router.go(-1);
    };
    return {
      itemvalue,
      goHomepage
    };
  }
});